import axios from 'axios';

// Due client axios distinti per gli endpoint di local_auth: userApi viene usato da
// qualunque utente autenticato (es. login, cambio della propria password, lettura dei
// propri permessi); adminApi viene usato solo per le operazioni riservate al superadmin
// (creazione utenti, reset password altrui, gestione permessi, cancellazione utenti).
// Il backend valida la key ricevuta nell'header X-API-Key.

export const userApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { 'X-API-Key': process.env.REACT_APP_LOCAL_AUTH_USER_API_KEY },
});

export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { 'X-API-Key': process.env.REACT_APP_LOCAL_AUTH_ADMIN_API_KEY },
});
